import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {AppState} from 'src/app/core/models/app.model';
import {SignalStore} from 'src/app/shared/functions/store.functions';
import {LoginFormComponent} from '../login-form/login-form.component';
import {SignUpComponent} from '../../account/sign-up/sign-up.component';
import {ForgotPasswordComponent} from '../../account/forgot-password/forgot-password.component';
import {NgIf} from '@angular/common';

import {KeycloakProfile} from 'keycloak-js';

import {KeycloakService} from "keycloak-angular";
import {environment} from 'src/environments/environment';


@Component({
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css'],
  standalone: true,
  imports: [
    NgIf,
    LoginFormComponent,
    SignUpComponent,
    ForgotPasswordComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginPageComponent {
  readonly title = this.appStore.select(state => state.name);
  readonly version = this.appStore.select(state => state.version);
  readonly author = this.appStore.select(state => state.author);
  readonly logo = this.appStore.select(state => state.logo);
  public isLoggedIn = false;
  public userProfile: KeycloakProfile | null = null;

  constructor(
    @Inject('app-store') private readonly appStore: SignalStore<AppState>,
    private readonly keycloak: KeycloakService
  ) {


  }

  async ngOnInit() {
    await this.login()


  }

  public async login() {
    await this.keycloak.login({
      redirectUri: environment.keycloak.redirectUrl,
    });
  }

  public async logout() {
    this.keycloak.logout();
  }
}
